// @flow
import React from "react";
import Lighting from "../../../svg/facilities/has_lighting.svg";
import "./lightingIcon.scss";

const LightingIcon = () => <Lighting className="c-lighting-icon" />;

export default LightingIcon;
